// extracted by mini-css-extract-plugin
module.exports = {"banner":"w_bC","banner__inner":"w_bD"};